function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 7,
  "data-name": "arrow drawn"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 459",
  d: "M4.769 49.318C12.705 46.599 20.645 43.89 28.643 42c15.913-3.708 32-4.272 48.069-4.835l17.497-.613",
  strokeWidth: 6.99727
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 460",
  d: "M50.04 6.593L97.413 37.22a.35.35 0 01-.058.612c-17.677 6.771-36.11 12.208-51.71 23.757",
  strokeWidth: 6.99727
}));

function SvgArrowDrawn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.11 66.664"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDIuMTEgNjYuNjY0Ij4KICA8ZyBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNyIgZGF0YS1uYW1lPSJhcnJvdyBkcmF3biI+CiAgICA8cGF0aCBkYXRhLW5hbWU9IlBhdGggNDU5IiBkPSJNNC43NjkgNDkuMzE4QzEyLjcwNSA0Ni41OTkgMjAuNjQ1IDQzLjg5IDI4LjY0MyA0MmMxNS45MTMtMy43MDggMzItNC4yNzIgNDguMDY5LTQuODM1bDE3LjQ5Ny0uNjEzIiBzdHJva2Utd2lkdGg9IjYuOTk3MjciLz4KICAgIDxwYXRoIGRhdGEtbmFtZT0iUGF0aCA0NjAiIGQ9Ik01MC4wNCA2LjU5M0w5Ny40MTMgMzcuMjJhLjM1LjM1IDAgMDEtLjA1OC42MTJjLTE3LjY3NyA2Ljc3MS0zNi4xMSAxMi4yMDgtNTEuNzEgMjMuNzU3IiBzdHJva2Utd2lkdGg9IjYuOTk3MjciLz4KICA8L2c+Cjwvc3ZnPg==";
export { SvgArrowDrawn as ReactComponent };